import type { CheckImportance } from "@/types/aicheck";

const STATUS_ORDER: Record<string, number> = {
  fail: 0,
  error: 1,
  warning: 2,
  pass: 3,
  skipped: 4,
  info: 5,
};
const IMPORTANCE_ORDER: Record<string, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  low: 3,
};

export function compareByStatusAndImportance(
  a: { status: string; importance?: CheckImportance | string },
  b: { status: string; importance?: CheckImportance | string },
): number {
  const sa = STATUS_ORDER[a.status] ?? 9;
  const sb = STATUS_ORDER[b.status] ?? 9;
  if (sa !== sb) return sa - sb;
  const ia = IMPORTANCE_ORDER[a.importance ?? "medium"] ?? 2;
  const ib = IMPORTANCE_ORDER[b.importance ?? "medium"] ?? 2;
  return ia - ib;
}
